// extracted by mini-css-extract-plugin
export default {"footerMain":"Footer_footerMain__ME+bA","logoContainer":"Footer_logoContainer__WwCF+","logo":"Footer_logo__P81wf","accmeLogo":"Footer_accmeLogo__Hbjb3"};